import script from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=3d9b4b48&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9b4b48"]])

export default __exports__